import type { IdempotencyKeyFactory } from "@/domain/port/IdempotencyKeyFactory";

export class IdempotencyKeyFactoryImpl implements IdempotencyKeyFactory {
  create(): string {
    if (
      typeof crypto !== "undefined" &&
      typeof crypto.randomUUID === "function"
    ) {
      return crypto.randomUUID();
    }

    return `idem-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
}
